module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/AYkDvT/tc-custom/9781426865084.jpg?1738298115765",
      "alt": "This image is the cover for the book Assignment: Bodyguard"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Assignment: Bodyguard\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("With him by her side, it’s not her life that’s in danger—it’s her heart. Romantic thrills from the "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author of "), _c('i', [_vm._v("Risky Reunion")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v("Her father will accept only the best for Kit Atkins’s protection. So when Kit is threatened, he calls on Shane Warwick, a CHAIM agent. Shane is calm, capable, protective—and way too charming for Kit’s peace of mind. Yet despite her protests, Shane refuses to leave her side. As they hide out at a remote Texas ranch, a powerful bond grows between them, even as danger rises. Connections to the mysterious death of Kit’s late husband reveal old betrayals. Suddenly, Kit’s assigned bodyguard is the only person she can trust.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lenora Worth\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0